import styled from 'styled-components';

const ClaroInputButton = styled.button`
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    background: none; 
    border: none; 
    outline: none;
    color: "#000";
    font-size: 0.7rem;
    line-height: auto;
    vertical-align: middle;
    border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
    -webkit-appearance: none;
    border-radius: 0;
    display:table-cell;
    min-height: 35px

`

export default ClaroInputButton;